import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MultiFilterType } from "@flowtribe/ui";

import { FilterObjectWithParamValue } from "../../../interfaces/filter-object.interface";
import { FILTER_TYPE_MAX_VISIBLE_ITEMS, MAX_FILTERS } from "../../utils/filter.util";

/** The filter bar of the overview screens: a `ui-multi-select-filter` with the app's labels and limits. */
@Component({
  standalone: false,
  selector: "app-overview-filter-bar",
  templateUrl: "./overview-filter-bar.component.html",
  host: { class: "block w-full" }
})
export class OverviewFilterBarComponent {
  @Input() filterArray: FilterObjectWithParamValue[] = [];
  @Input() filterTypes: MultiFilterType[] = [];
  @Input() hasActiveFilters = false;
  /** Width of the filter rows beside the add and clear buttons. */
  @Input() filterFieldsWidthClass = "w-1/2";
  @Output() filterArrayChange = new EventEmitter<FilterObjectWithParamValue[]>();
  /** A search was started, or a row was removed. */
  @Output() searchTriggered = new EventEmitter<void>();
  @Output() searchInputCleared = new EventEmitter<number>();
  @Output() clearFiltersClicked = new EventEmitter<void>();

  public readonly maxFilters = MAX_FILTERS;
  public readonly filterTypeMaxVisibleItems = FILTER_TYPE_MAX_VISIBLE_ITEMS;
}
